/**
 * Copyright (c) 2015-present, Alibaba Group Holding Limited.
 * All rights reserved.
 *
 * @providesModule ReactProcessColor
 */
'use strict';

function processColor(color) {
  return color;
}

module.exports = processColor;


/** WEBPACK FOOTER **
 ** ./~/react-native-winjs/lib/StyleSheet/processColor.winjs.js
 **/